import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import IntercomWidget from "../common/components/IntercomWidget";
import Footer from "../components/common/Footer";

export const MainLayout = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <IntercomWidget />
    </Box>
  );
};
